import { setUserCookie } from "helpers/cookie";
import { setStoredModule } from "helpers/module";
import { fetchTranslation } from "store/userSlice";

export function isLicenseBlockedTranslationResult(result) {
  return result?.meta?.requestStatus === 'rejected'
    && result?.payload?.statusCode === 402;
}

// Shared post-login steps for the Keycloak callback and impersonation.
// Returns { blocked: true } when the license blocks translations (402); the caller handles its own cleanup.
export async function runPostLogin(dispatch, data) {
  if (data?.initial_module || data?.initial_mode) {
    setStoredModule(data.initial_module || data.initial_mode);
  }

  setUserCookie();

  const translationResult = await dispatch(fetchTranslation(true));
  if (isLicenseBlockedTranslationResult(translationResult)) {
    return { blocked: true };
  }

  sessionStorage.removeItem('skip_autologin');
  window.location.href = '/employee-management?with=changelogs';
  return { blocked: false };
}
